import React from "react";
import { View, Text, TextInput } from "ui";

interface P {
  title: string;
  subtitle: string;
}

const PremiumButton = ({ title, subtitle }: P) => {
  return (
    <View
      flex={1}
      bg="blue"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      p={2}
      borderRadius={50}
    >
      <Text mr={2} color="white" fontSize={5}>
        {title}
      </Text>
      <Text mr={2} color="white" fontSize={2}>
        {subtitle}
      </Text>
    </View>
  );
};

export default PremiumButton;



// WEBPACK FOOTER //
// ./src/components/PremiumButton.tsx